import { render, staticRenderFns } from "./UdfRuntimes.vue?vue&type=template&id=1a97e46e"
import script from "./UdfRuntimes.vue?vue&type=script&lang=js"
export * from "./UdfRuntimes.vue?vue&type=script&lang=js"
import style0 from "./UdfRuntimes.vue?vue&type=style&index=0&id=1a97e46e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports